App.prototype.mobilePaginationControls = function () {

    var el_opts = $('[data-options]');
    if (el_opts) {

        var opts = el_opts.data('options');

        new MobileSelect({
            trigger: '#show-select-pagination',
            title: el_opts.data('title'),
            ensureBtnText: el_opts.data('ensure'),
            cancelBtnText: el_opts.data('cancel'),
            wheels: [
                {data: opts}
            ],
            callback: function (indexArr, data) {
                if (data.length) {
                    location.href = data[0].id
                }
            },
        });

    }

};

App.prototype.mobilePaginationControls('search-page', cartInit);
